import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const EditTaskPage = withSuspense(
	lazy(async () => await import('./edit-task-page.component')),
	PageLoader,
);
